export default "__VITE_ASSET__BJAeWxAy__"